import { Container, Grid, Typography, makeStyles } from "@material-ui/core";

import { ITheme } from "../constants/theme";

export type DeliveryFailedReason =
  | "UNABLE_TO_LOCATE"
  | "NONE"
  | "DELIVERY_INCIDENT"
  | "DESTINATION_INCORRECT"
  | "OTHER"
  | "UNAVAILABLE";

export const deliveryFailedMappings = {
  UNABLE_TO_LOCATE: "Unable to locate",
  NONE: "None",
  DELIVERY_INCIDENT: "Delivery Incident",
  DESTINATION_INCORRECT: "Destination is incorrect",
  OTHER: "Other",
  UNAVAILABLE: "Unavailable",
};

export const deliveryFailedString = (reason: DeliveryFailedReason) => {
  return deliveryFailedMappings[reason] ?? reason;
};

interface IOrderFailureProps {
  reason: DeliveryFailedReason;
  notes: string;
}

export const OrderDetailsFailureWarning = ({
  reason,
  notes,
}: IOrderFailureProps) => {
  const classes = useStyles();
  return (
    <Container className={classes.container}>
      <Grid container>
        <Grid container className={classes.infoTitle}>
          <Typography variant="h6" component="span">
            Delivery failure reason
          </Typography>
        </Grid>
        <Grid container className={classes.infoTextContainer}>
          <Grid item xs={3}>
            <Typography
              display="inline"
              variant="caption"
              component="span"
              color="textSecondary"
              data-automation="order-id-main"
            >
              FAILURE REASON
            </Typography>
          </Grid>
          <Grid item xs={7} className={classes.colOffset}>
            <Typography variant="body1" component="span" color="textPrimary">
              {deliveryFailedString(reason)}
            </Typography>
          </Grid>
        </Grid>
        <Grid container className={classes.infoTextContainer}>
          <Grid item xs={3}>
            <Typography
              display="inline"
              variant="caption"
              component="span"
              color="textSecondary"
            >
              FAILURE NOTE
            </Typography>
          </Grid>
          <Grid item xs={7} className={classes.colOffset}>
            <Typography variant="body1" component="span" color="textPrimary">
              {notes || "-"}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
};

const useStyles = makeStyles((theme: ITheme) => ({
  container: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "center",
    padding: "18px 24px 0",
    border: "1px solid rgba(158, 0, 93, 0.08)",
    boxSizing: "border-box",
    borderRadius: "20px",
    marginBottom: "20px",
    backgroundColor: "rgba(158, 0, 93, 0.12)",
  },
  infoTitle: {
    marginBottom: 20,
  },
  infoTextContainer: {
    paddingTop: 15,
    paddingBottom: 15,
  },
  infoTextContainerLastRow: {
    paddingTop: 15,
    paddingBottom: 15,
  },
  colOffset: {
    marginLeft: -17.5,
    marginRight: 17.5,
  },
}));
